var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Link, Spinner, Text } from 'pcln-design-system';
import { useOtpContext } from '../../context/OtpContext';
import otpService from '../../utils/otpService';
import styled from 'styled-components';
import { ChatbotDataContext } from '../../context/ChatbotDataContext';
const StyledLink = /*#__PURE__*/styled(Link).withConfig({
  displayName: "ResentButton__StyledLink",
  componentId: "sc-tlpfhc-0"
})(["text-decoration:underline;", ""], ({
  disabled
}) => disabled && `
  text-decoration: none;
  `);
const ResendButton = ({
  validOtpCode
}) => {
  const errorMessage = 'I’m having some trouble accessing your trip information. ';
  const {
    setOtpRequestErrorMsg,
    otpResent,
    setOtpResent,
    setVerificationApiFunction,
    resendInProgress,
    setResendInProgress,
    otpFormData,
    otpDeliveryType
  } = useOtpContext();
  const [totalResendCount, setTotalResendCount] = useState(1);
  const otpServiceInstance = useMemo(() => otpService({
    deliveryType: otpDeliveryType
  }), [otpService]);
  const {
    phoneNumber,
    email,
    countryCode
  } = otpFormData || {};
  const [disableResendButton, setDisableResendButton] = useState(true);
  const {
    submitChatMessagesPayload,
    requestFrom
  } = useContext(ChatbotDataContext);
  const {
    cguid,
    resolvedClientIP
  } = submitChatMessagesPayload || {};
  const disableResendButtonFn = () => {
    setTimeout(() => {
      setDisableResendButton(false);
    }, 120000); // 2 minutes
  };
  useEffect(() => {
    disableResendButtonFn();
  }, []);
  function resendSmsCode(e) {
    return __awaiter(this, void 0, void 0, function* () {
      setTotalResendCount(totalResendCount + 1);
      setResendInProgress(true);
      setOtpRequestErrorMsg('');
      try {
        const otpChallenge = yield otpServiceInstance.createChallenge({
          phoneNumber,
          email,
          countryCode,
          scope: 'trips',
          requestHeaders: {
            'x-pcln-client-ip': resolvedClientIP,
            cguid
          },
          requestFrom
        });
        if (otpChallenge) {
          setVerificationApiFunction(() => otpServiceInstance.verify);
          setOtpResent(true);
        } else {
          setOtpRequestErrorMsg(errorMessage);
        }
      } catch (e) {
        setOtpRequestErrorMsg(errorMessage);
      } finally {
        setDisableResendButton(true);
        setResendInProgress(false);
        if (totalResendCount <= 4) {
          disableResendButtonFn();
        }
      }
    });
  }
  return React.createElement(React.Fragment, null, resendInProgress ? React.createElement(Spinner, null) : React.createElement(React.Fragment, null, !validOtpCode && React.createElement(React.Fragment, null, React.createElement(Text, {
    mt: 2,
    fontSize: 0
  }, "Didn't get the message?", ' ', React.createElement(StyledLink, {
    disabled: disableResendButton,
    onClick: resendSmsCode
  }, "Resend")), otpResent ? React.createElement(Text, {
    fontWeight: 'bold'
  }, "Message re-sent.") : null)));
};
export default ResendButton;